import { put, call, takeEvery } from "redux-saga/effects";
import { IMAGE, ENDPOINT } from "../constants";
import { setPageTopLoader, setAllImageDataByFileName } from "../actions";
import { getDataFromKpiDash } from "../api";

const S3_BUCKET_BASE_URL = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const selectAllImageData = (state) => state.image.allImageDataByFilename;

export function buildQueryGetPpa(fileName) {
  const safeFileName = fileName.replace(/'/g, "''");
  return {
    query: `
      SELECT
        ppa.id AS ppa_id,
        ppa.file_name,
        ppa.object_key,
        ppa.power_asset_id,
        ppa.player_id,
        ppa.game_space_id
      FROM photo_of_power_asset ppa
      WHERE ppa.file_name = '${safeFileName}'
      ORDER BY ppa.id DESC
      LIMIT 1;
    `
  };
}

export function buildQueryGetReviewRequestId(powerAssetId, playerId, gameSpaceId) {
  return {
    query: `
      SELECT rr.id AS review_request_id
      FROM review_request rr
      JOIN review_request_event rre
        ON rre.review_request_id = rr.id
      WHERE rr.power_asset_id = '${powerAssetId}'
        AND rr.player_id = '${playerId}'
        AND rr.game_space_id = '${gameSpaceId}'
        AND rre.type = 'APPLIED'
      ORDER BY rre.occurred_datetime DESC
      LIMIT 1;
    `
  };
}

export function buildQuery2ByFileName(fileName, reviewRequestId) {
  const env = process.env.REACT_APP_ENV;
  const companyTableName =
    localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
      ? "power_asset_detail_of_ntt_me"
      : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
      ? "power_asset_detail_of_hepco"
      : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
      ? env === "prod"
        ? "power_asset_detail_of_ntt_ft"
        : "power_asset_detail_of_ntt_me"
      : localStorage.getItem("access_key") === "k4x9d2p7m0v1q8t5wryb3zfn6"
        ? "power_asset_detail_of_ntt_ft"
        : "power_asset_detail_of_tepco";

  const safeFileName = fileName.replace(/'/g, "''");
  const reviewRequestFilterQuery = reviewRequestId
    ? `AND rrrrib.review_request_id = '${reviewRequestId}'`
    : "";

  return {
    query: `
      WITH target AS (
        SELECT
          ppa.power_asset_id,
          ppa.player_id,
          ppa.game_space_id,
          rrrrib.review_request_id,
          rre.occurred_datetime
        FROM photo_of_power_asset ppa
        JOIN review_image_info rii ON rii.photo_of_power_asset_id = ppa.id
        JOIN review_request_info_review_image_bind rririb ON rririb.review_image_info_id = rii.id
        JOIN review_request_info rri ON rri.id = rririb.review_request_info_id
        JOIN review_request_review_request_info_bind rrrrib ON rrrrib.review_request_info_id = rri.id
        JOIN review_request rr ON rr.id = rrrrib.review_request_id
        JOIN review_request_event rre
          ON rre.review_request_id = rr.id
        AND rre.type = 'APPLIED'
        WHERE ppa.file_name = '${safeFileName}'
        ${reviewRequestFilterQuery}
        ORDER BY rre.occurred_datetime DESC
        LIMIT 1
      )
      SELECT
        ppa.*,
        gs.*,
        gt.*,
        ps.*,
        padtep.*,
        DATE_FORMAT(
          CONVERT_TZ(t.occurred_datetime, '+00:00', '+09:00'),
          '%Y-%m-%d %H:%i:%s'
        ) AS occurred_datetime_jst
      FROM target t
      JOIN photo_of_power_asset ppa
        ON ppa.power_asset_id = t.power_asset_id
      AND ppa.player_id      = t.player_id
      AND ppa.game_space_id  = t.game_space_id
      JOIN review_request_review_request_info_bind rrrrib
        ON rrrrib.review_request_id = t.review_request_id
      JOIN review_request_info rri ON rri.id = rrrrib.review_request_info_id
      JOIN review_request_info_review_image_bind rririb
        ON rririb.review_request_info_id = rri.id
      JOIN review_image_info rii
        ON rii.photo_of_power_asset_id = ppa.id
      AND rririb.review_image_info_id = rii.id
      JOIN game_space gs ON gs.id = ppa.game_space_id
      JOIN game_term gt ON gt.id = gs.game_term_id
      JOIN player_state ps ON ps.player_id = ppa.player_id
      JOIN ${companyTableName} padtep ON ppa.power_asset_id = padtep.power_asset_id
      ORDER BY ppa.file_name ASC;
    `
  };
}

export function* handleAllImageDataByFileName(action) {
  try {
    yield put(setPageTopLoader(true));

    const fileNames = action.payload; // 配列
    let allImageUrls = [];

    const fetchedGroupKeys = new Set(); // 重複クエリ防止

    // 各ファイル名に対して処理
    for (const url of fileNames) {
      const decodedUrl = decodeURIComponent(url);
      const fileName = decodedUrl.split("/").pop();

      // ① ppa取得
      const sqlGetPpa = buildQueryGetPpa(fileName);
      const ppaTemp = yield call(getDataFromKpiDash, sqlGetPpa, ENDPOINT.GET_DATA_API_REPLICA);
      const ppaRows = JSON.parse(ppaTemp.body || "[]");
      if (!ppaRows.length) {
        console.warn(`No ppa found for file: ${fileName}`);
        continue;
      }

      const { power_asset_id, player_id, game_space_id } = ppaRows[0];

      // ② review_request_id 取得
      let reviewRequestId;
      try {
        const sqlGetReviewRequestId = buildQueryGetReviewRequestId(
          power_asset_id,
          player_id,
          game_space_id
        );
        const reviewRequestTemp = yield call(
          getDataFromKpiDash,
          sqlGetReviewRequestId,
          ENDPOINT.GET_DATA_API_REPLICA
        );
        const reviewRequestRows = JSON.parse(reviewRequestTemp.body || "[]");
        reviewRequestId = reviewRequestRows?.[0]?.review_request_id;
      } catch (_error) {
        reviewRequestId = undefined;
      }

      // ③ ここで “同一グループ” の重複を避ける
      const groupKey = reviewRequestId ? `rr:${reviewRequestId}` : `fn:${fileName}`;
      if (fetchedGroupKeys.has(groupKey)) continue;
      fetchedGroupKeys.add(groupKey);

      // ④ 新構成クエリ（reviewRequestId は存在時のみフィルタ）
      const sqlQuery2 = buildQuery2ByFileName(fileName, reviewRequestId);

      const imageFilesDataTemp = yield call(getDataFromKpiDash, sqlQuery2, ENDPOINT.GET_DATA_API_REPLICA);
      const imageFilesData = JSON.parse(imageFilesDataTemp.body || "[]");

      const imageUrls = imageFilesData.map(
        (photoData) => `${S3_BUCKET_BASE_URL}/${photoData.object_key}`
      );

      allImageUrls = allImageUrls.concat(imageUrls);
    }

    //重複を排除して一括で Redux に更新
    const uniqueData = Array.from(new Set(allImageUrls));
    yield put(setAllImageDataByFileName(uniqueData));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.error(error);
    yield put(setPageTopLoader(false));
    yield put({ type: IMAGE.ERROR, payload: error.message });
  }
}
export default function* watchMapSettings() {
  yield takeEvery(IMAGE.GET_ALL_IMAGE_DATA_BY_FILENAME, handleAllImageDataByFileName);
}
